// Generated by scripts/build-ui-icons.mjs.
export { Info as default } from "../ui/glyphs-4";
